<template>
  <div>
    <v-toolbar class="my-5">
      <v-toolbar-title>{{ $t('BUILDINGS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small class="ml-2" @click="dialogImport = true">
        {{ $t('BUTTON.IMPORT') }}
      </v-btn>
      <v-btn dark color="indigo" class="ml-2" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('BUILDINGS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-dialog
      v-if="dialogImport"
      v-model="dialogImport"
      persistent
      max-width="500px"
    >
      <ImportBuildingsWithApartments
        :id-building-complex="idBuildingComplex"
        @cancel="dialogImport = !dialogImport"
        @success="executedImport"
      ></ImportBuildingsWithApartments>
    </v-dialog>

    <v-data-table
      v-model="selectedBuildings"
      :headers="headers"
      :loading="!!!buildings"
      :items="buildings"
      :sort-by="'id'"
      :sort-desc="true"
      :items-per-page="10"
      show-select
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:item.type="{ item }">
        {{ getHouseType(item.type).name }}
      </template>

      <template v-slot:item.elevator="{ item }">
        <v-checkbox v-model="item.elevator" disabled></v-checkbox>
      </template>

      <template v-slot:item.keysafe="{ item }">
        <v-checkbox
          v-if="item.id === item.keysafe_house_building_id"
          v-model="flag"
          disabled
        ></v-checkbox>
        <v-checkbox v-else disabled></v-checkbox>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="show(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="1000px"
    >
      <component
        :is="component.name"
        v-model="component.data"
        :id-building-complex="idBuildingComplex"
        :keysafe-houses="keysafeHouses"
        :keysafe-houses-linked="keysafeHousesLinked"
        @created="cancelDialogAndRefresh"
        @updated="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import buildingTypes from '@/modules/buildings/components/mixins/buildings-types';

export default {
  name: 'BuildingsOfBuildingComplex',

  components: {
    ShowBuilding: () => import('@/modules/buildings/components/ShowBuilding'),
    CreateBuilding: () =>
      import('@/modules/buildings/components/CreateBuilding'),
    ImportBuildingsWithApartments: () =>
      import('@/modules/import/components/ImportBuildingsWithApartments')
  },

  mixins: [buildingTypes],

  props: {
    idBuildingComplex: {
      type: Number,
      required: true
    },
    selectedBuilding: {
      type: Object,
      default: () => {}
    },
    refreshBuildings: {
      type: Boolean
    }
  },

  data: () => ({
    dialog: false,
    component: null,

    buildings: [],
    keysafeHouses: [],
    keysafeHousesLinked: null,

    dialogImport: false,
    dialogCreate: false,
    dialogShow: false,
    dialogEdit: false,
    flag: true,
    selectedBuildings: [],

    building: null
  }),

  computed: {
    headers() {
      return [
        {
          text: 'ID',
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'street'
        },
        {
          text: this.$t('PROFILE.NAME'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        },
        {
          text: this.$t('BUILDINGS.ELEVATOR'),
          value: 'elevator'
        },
        // {
        //     text: 'Manual',
        //     value: 1,
        // },
        {
          text: this.$t('BUILDINGS.KEY_SAFE'),
          value: 'keysafe'
        },
        {
          text: this.$t('BUILDINGS.KEY_SAFE_HOUSE'),
          value: 'keysafe_house.street'
        },
        {
          text: this.$t('APARTMENTS.ITEMS'),
          value: 'apartments_count'
        },
        {
          text: this.$t('BUILDINGS.INHABITANTS'),
          value: 'inhabitants_count'
        },
        { text: '', value: 'action', align: 'center' }
      ];
    }
  },

  watch: {
    refreshBuildings: 'refreshData',
    selectedBuildings: function(val) {
      this.$emit('addSelectedBuildings', val);
    }
  },

  created() {
    this.refreshData();

    // for selected building from buildings_menu
    if (this.selectedBuilding)
      this.selectedBuildings.push(this.selectedBuilding);
  },

  methods: {
    ...mapActions('building', ['retrieveBuilding']),

    getDataBuilding(id = this.value.id) {
      return this.retrieveBuilding(id)
        .then(({ data }) => {
          this.building = { ...data };

          return data;
        })
        .catch(error => {
          this.error = error;
        });
    },

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateBuilding'
      };
    },

    show(item) {
      this.getDataBuilding(item.id).then(data => {
        this.dialog = true;
        this.component = {
          name: 'ShowBuilding',
          data: data
        };
      });
    },

    edit(item) {
      this.dialog = true;
      this.component = {
        name: 'EditBuilding',
        data: item
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },

    executedImport() {
      this.dialogImport = !this.dialogImport;
      this.refreshData();
    },

    refreshData() {
      this.$store
        .dispatch(
          'building/retrieveBuildingsOfBuildingComplex',
          this.idBuildingComplex
        )
        .then(({ data }) => {
          this.buildings = data.data;

          let keysafeHouses = [];
          data.data.forEach(building => {
            if (building.id == building.keysafe_house_building_id)
              keysafeHouses.push(building);
          });
          this.keysafeHouses = keysafeHouses;

          let keysafeHousesLinked = new Set();
          data.data.forEach(building => {
            if (
              building.id != building.keysafe_house_building_id &&
              building.keysafe_house_building_id != null
            )
              keysafeHousesLinked.add(building.keysafe_house_building_id);
          });
          this.keysafeHousesLinked = keysafeHousesLinked;
        })
        .then(() => {
          let selecteedids = this.selectedBuildings.map(m => m.id);
          let filteredData = this.buildings.filter(e =>
            e ? selecteedids.includes(e.id) : null
          );
          this.selectedBuildings = filteredData;
        })
        .catch(() => {});
    }
  }
};
</script>
